<template>
	<GeneralTableCost
		:fromModal="fromModal"
		:isLastItem="isLastItem"
		:tableTitle="tableTitle"
		:costs-table="costsTable"
		:parent-costs-table="parentCostsTable"
		:project="project"
		:contract="costsTable.contract"
		:colors="colors"
		:colorVars="colorVars"
		:ufValueBase="ufValueBase"
		:currency="currency"
		:col-widths="colWidths"
		:can-show-reception-section="canShowReceptionSection"
		:cost_categories_config="cost_categories_config"
		:addStage="addStage"
		:addProject="addProject"
		:addSpecialty="addSpecialty"
		:addReception="addReception"
		:updateStage="updateStage"
		:updateSpecialty="updateSpecialty"
		:updateSurfaceItems="updateSurfaceItems"
		:updateCostItems="updateCostItems"
		:removeProject="removeProject"
		:removeReception="removeReception"
		:onChangeSecondaryCostProject="onChangeSecondaryCostProject"
		:onChangeSecondaryCostProjectItem="onChangeSecondaryCostProjectItem"
		:updateReception="updateReception"
		@open-summary-modal="$store.commit('costbreakdown/setCostBreakdownSummaryTablesModal', true)"
	/>
</template>

<script>
// import _debounce from 'lodash/debounce'
import GeneralTableCost from '@/components/Views/Projects/TableCostParts/GeneralTableCost.vue'
import {saveProjectCostDetail} from '@/helpers/api/costs'

export default {
	name: 'SecondaryTableCost',
	components: {
		GeneralTableCost
	},
	props: {
		fromModal: {
			type: Boolean,
			default: false
		},
		parentCostsTable: {
			type: Object,
			required: true
		},
    costsTable: {
      type: Object,
      required: true
    },
    project: {
      type: Object,
      required: true
    },
		cost_categories_config: {
			type: Array,
			required: false
		},
    colors: {
      type: Object,
      required: true
    },
		selectedUfValue: {
      type: Object,
      required: false
    },
    colorVars: {
      type: Array,
      default: () => []
    },
    ufValueBase: {
      type: Number,
      required: true
    },
    currency: {
      type: String,
      default: 'uf'
    },
    colWidths: {
      type: Array,
      default: () => ['30%','10%','10%','15%','12%','15%','8%']
    },
		canShowReceptionSection: {
			type: Boolean,
			default: false
		},
		isLastItem: {
			type: Boolean,
			default: false
		}
	},
	computed: {
		tableTitle() {
			if(this.costsTable.contract) {
				const contract = this.costsTable.contract
				if(contract.addendum_index){
					return `Tabla de Costos - Anexo Nº ${contract.addendum_index}: ${contract.serial?.serial} - LP${this.project?.project_line_info?.project_line?.number} - ${contract.contract_info?.prefix?.prefix} ${contract.contract_info?.contract_prefix_index}`	
				}
				return `Tabla de Costos: ${contract.serial?.serial} - LP${this.project?.project_line_info?.project_line?.number} - ${contract.contract_info?.prefix?.prefix} ${contract.contract_info?.contract_prefix_index}`
			}
			return 'Tabla de Costos'
		}
	},
	methods: {
		startSaveCostTable(forceSave = true, gotcostTableUpdated = false){
			this.$emit('update:secondaryTableCost', {
				costs_table: this.costsTable,
				force_save: forceSave,
				get_cost_table_updated: gotcostTableUpdated
			})
		},
		// startSaveCostTable: _debounce(function(get_cost_table_updated = false) { this.saveCostsTable(get_cost_table_updated) }, 800),
		async saveCostsTable(get_cost_table_updated = true){
			const data = {...this.costsTable, project_cost_id: this.costsTable.id, uf_value_id: this.selectedUfValue?.id, get_cost_table_updated}
			console.log('SAVE this.costsTable Secondary')
			const save_costs = await saveProjectCostDetail(data)
			if(save_costs.code == 200){
				if(save_costs.project_cost){
					this.costsTable = JSON.parse(JSON.stringify(save_costs.project_cost))
					//Prueba sacar
					this.costsTable = {...this.costsTable, ...{supervisions: {supervisions: [], supervisionsB: [], difference: null}}}
				}
				const messageData = {
					message: 'Tabla de Costo guardada correctamente',
					title: 'Tabla de Costo Guardada',
					type: 'success',
					icon: 'mdi-check-circle',
					color: '#3EBFA3',
				}
				this.setMessage(messageData)
			}
			else{
				const messageData = {
					message: 'Hubo un error en la operación, por favor intenta nuevamente',
					title: 'Ha ocurrido un error',
					type: 'danger',
					icon: 'mdi-close-octagon',
					color: '#FF1209',
				}
				this.setMessage(messageData)
			}
		},
		addStage(){
			const newItem = {
				id: null,
				company_stage_id: null,
				stage: null,
				qty: 0,
				unit_cost_uf: 0,
				unit_cost_clp: 0
			}
			const updatedProjectStage = [...this.costsTable.stages]
			updatedProjectStage.push(newItem)
			this.costsTable = {
				...this.costsTable,
				...{stages: updatedProjectStage}
			}
			this.startSaveCostTable(true, true);
		},
		addProject(){
			const newItem = {
				id: null,
				project_id: null,
				project: null,
				items: []
			}
			const updatedProjects = [...this.costsTable.projects]
			updatedProjects.push(newItem)
			this.costsTable = {
				...this.costsTable,
				...{projects: updatedProjects}
			}
			this.startSaveCostTable(true, true);
		},
		removeProject(projectIndex) {
			if (this.costsTable.projects && this.costsTable.projects[projectIndex]) {
				this.costsTable.projects.splice(projectIndex, 1);
				this.startSaveCostTable();
			}
		},
		onChangeSecondaryCostProject(project, index){
			let newProject = this.costsTable.projects[index]
			newProject = {
				...newProject,
				...{
					project_id: project.id,
					project
				}
			}
			this.costsTable.projects.splice(index, 1, newProject)
			this.startSaveCostTable()
		},
		onChangeSecondaryCostProjectItem(items, index){
			let newProject = this.costsTable.projects[index]
			newProject = {
				...newProject,
				...{
					items
				}
			}
			this.costsTable.projects.splice(index, 1, newProject)
			this.startSaveCostTable()
		},
		updateStage(val, index){
			val ? this.costsTable.stages.splice(index, 1, val):this.costsTable.stages.splice(index, 1)
			this.startSaveCostTable();
		},
		addReception(forced_reception = false){
			const newItem = {
				id: null,
				name: 'Recepción Final',
				qty: 0,
				unit_cost_uf: 0,
				unit_cost_clp: 0,
				items: []
			}
			this.costsTable = {
				...this.costsTable,
				reception: newItem,
				...(forced_reception && { with_reception: true })
			}
			this.startSaveCostTable(true, true);
		},
		removeReception(){
			this.costsTable.reception = null
			this.startSaveCostTable();
		},
		updateReception(items){
			if(!items || items.length == 0){
				this.costsTable.reception = null
				return;
			}
			if (!this.costsTable.reception) {
				this.costsTable.reception = {}
			}
			this.costsTable.reception.items = items
			this.startSaveCostTable();
		},
		addSpecialty(){
			const newItem = {
				id: null,
				company_specialty_id: null,
				specialty: null,
				qty: 0,
				unit_cost_uf: 0,
				unit_cost_clp: 0
			}
			const updatedProjectSpecialties = [...this.costsTable.specialties]
			updatedProjectSpecialties.push(newItem)
			this.costsTable = {
				...this.costsTable,
				...{specialties: updatedProjectSpecialties}
			}
			this.startSaveCostTable(true, true);
		},
		updateSpecialty(val, index) {
			if (!val) {
				this.costsTable.specialties.splice(index, 1);
			} else {
				this.costsTable.specialties.splice(index, 1, val);
			}
			this.startSaveCostTable();
		},
		updateSurfaceItems(items) {
			if(!items){
				this.costsTable.surfaces = null
				return;
			}
			if (!this.costsTable.surfaces) {
				this.costsTable.surfaces = {}
			}
			this.costsTable.surfaces.items = items
			this.startSaveCostTable();
		},
		updateCostItems(items) {
			if(!items){
				this.costsTable.items = []
				return;
			}
			this.costsTable.items = items
			this.startSaveCostTable();
		},
		setMessage(messageData){
			const data = {
				message: messageData.message,
				title: messageData.title,
				created: new Date(),
				type: messageData.type,
				icon: messageData.icon,
				color: messageData.color,
			}
			this.$store.dispatch('general/addMessage', data)
		},
	}
}
</script>